import type { LayerKey } from '@festina-life/api'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useTemplateIsLibrary } from '../hooks/useTemplateIsLibrary'
import { useOperationsContext } from '../workspace/operationsContext'
import { configurationItem } from './paths'
import { useNavigationParams } from './useNavigationParams'

export const useTemplateNavigation = () => {
  const navigate = useNavigate()
  const { server, branch } = useNavigationParams()
  const { workspaceKey } = useOperationsContext()
  const templateIsLibrary = useTemplateIsLibrary()

  return useCallback(
    ({
      templateId,
      layer,
      block,
    }: {
      templateId: string
      layer: LayerKey
      block: string
    }) =>
      navigate(
        configurationItem({
          workspaceName: workspaceKey?.name,
          server,
          itemId: templateId,
          block,
          layer,
          branch,
          type: templateIsLibrary(templateId) ? 'library' : 'template',
        }),
      ),
    [branch, navigate, server, templateIsLibrary, workspaceKey?.name],
  )
}
